export const CACHE_UP_KEYS = {
    conditionReport: "conditionReports",
}